// PDP Shipping Estimate — client-side date computation
(() => {
  const MONTHS_LONG = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  const MONTHS_SHORT = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
  const DAYS_LONG = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
  const DAYS_SHORT = ['dom','lun','mar','mié','jue','vie','sáb'];

  const pad = (n) => String(n).padStart(2, '0');

  const formatDate = (date, fmt) => {
    return fmt.replace(/%[aAbBdejHIMmpSyY%-]+/g, (token) => {
      switch (token) {
        case '%a': return DAYS_SHORT[date.getDay()];
        case '%A': return DAYS_LONG[date.getDay()];
        case '%b': return MONTHS_SHORT[date.getMonth()];
        case '%B': return MONTHS_LONG[date.getMonth()];
        case '%d': return pad(date.getDate());
        case '%-d': return String(date.getDate());
        case '%e': return String(date.getDate()).padStart(2, ' ');
        case '%m': return pad(date.getMonth() + 1);
        case '%-m': return String(date.getMonth() + 1);
        case '%Y': return String(date.getFullYear());
        case '%y': return String(date.getFullYear()).slice(-2);
        case '%H': return pad(date.getHours());
        case '%I': return pad(((date.getHours() + 11) % 12) + 1);
        case '%M': return pad(date.getMinutes());
        case '%S': return pad(date.getSeconds());
        case '%p': return date.getHours() < 12 ? 'AM' : 'PM';
        case '%%': return '%';
        default: return token;
      }
    });
  };

  const addBusinessDays = (date, days, skipWeekends) => {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (skipWeekends) {
        const wd = d.getDay();
        if (wd === 0 || wd === 6) continue;
      }
      added++;
    }
    return d;
  };

  const init = () => {
    document.querySelectorAll('[data-shipping-estimate]').forEach((el) => {
      const days = parseInt(el.dataset.days || '0', 10);
      const skipWeekends = el.dataset.skipWeekends === 'true';
      const cutoffHour = parseInt(el.dataset.cutoffHour || '0', 10);
      const fmt = el.dataset.dateFormat || '%a, %-d %b';

      const now = new Date();
      let extraDay = 0;
      if (cutoffHour > 0 && now.getHours() >= cutoffHour) extraDay = 1;

      let totalDays = days + extraDay;
      const target = addBusinessDays(now, totalDays, skipWeekends);

      const target_el = el.querySelector('[data-shipping-date]');
      if (target_el) target_el.textContent = formatDate(target, fmt);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
